import * as React from "react"

export function HighlightText({
  text,
  query,
  mountDelay = 0,
}: {
  text: string
  query: string
  mountDelay?: number
}) {
  if (!query.trim() || !text) return <>{text}</>

  const escaped = query.trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const parts = text.split(new RegExp(`(${escaped})`, "gi"))

  let matchIndex = 0
  return (
    <>
      {parts.map((part, i) => {
        if (i % 2 !== 1) return part
        const delay = mountDelay + matchIndex++ * 50
        return (
          <mark
            key={`${query}-${i}`}
            className="rounded-[2px] px-0 text-inherit"
            style={{
              // background-size only works on background-image, not background-color.
              // A single-stop gradient IS an image, so background-size sweeps it left→right.
              backgroundColor: "transparent",
              backgroundImage: `linear-gradient(var(--highlight-color), var(--highlight-color))`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "left center",
              // fill-mode:both applies the `from` keyframe (0% width) during the delay,
              // preventing a flash of full-width highlight before the sweep starts.
              animation: `highlight-sweep 0.45s cubic-bezier(0.25,1,0.5,1) ${delay}ms both`,
            }}
          >
            {part}
          </mark>
        )
      })}
    </>
  )
}
